const uregistrerteSitePaths = {
  shortUrl: "/uregistrerte",
  page: "/uregistrerte/:path",
  kontroller: {
    shortUrl: "/uregistrerte/kontroller",
    detalj: {
      route: "/uregistrerte/kontroller/:id",
      getUrl: (kontrollId) => `/uregistrerte/kontroller/${kontrollId}`,
    },
  },
};

export default uregistrerteSitePaths;
